var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    { attrs: { label: "除外する会員を指定", "has-child": "" } },
    [
      _c(
        "scout-form",
        {
          attrs: {
            "is-modified": _vm.isModifiedThisJob,
            label: "この自社求人でスカウトした時期を指定して除外",
            "data-test": "scout-this-job",
          },
        },
        [
          _c("term-select", {
            attrs: {
              "selected-option": _vm.scoutThisJobOption,
              from: _vm.scoutThisJobFrom,
              to: _vm.scoutThisJobTo,
              "without-today": true,
              "date-label": "スカウト送信日",
              notice:
                "※現在の掲載期間中にスカウトした会員は、スカウト済み一覧から再送できるため、すでに除外されています。現在の掲載期間よりも前にスカウトしたことがある会員を除外したい場合に、こちらを指定してください。",
            },
            on: {
              "update:selectedOption": function ($event) {
                return _vm.$emit("update:scoutThisJobOption", $event)
              },
              "update:from": function ($event) {
                return _vm.$emit("update:scoutThisJobFrom", $event)
              },
              "update:to": function ($event) {
                return _vm.$emit("update:scoutThisJobTo", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "scout-form",
        {
          attrs: {
            "is-modified": _vm.isModifiedOtherJob,
            label: "その他の自社求人でスカウトした時期を指定して除外",
            "data-test": "scout-other-job",
          },
        },
        [
          _c("term-select", {
            attrs: {
              "selected-option": _vm.scoutOtherJobOption,
              from: _vm.scoutOtherJobFrom,
              to: _vm.scoutOtherJobTo,
              "without-today": true,
              "date-label": "スカウト送信日",
            },
            on: {
              "update:selectedOption": function ($event) {
                return _vm.$emit("update:scoutOtherJobOption", $event)
              },
              "update:from": function ($event) {
                return _vm.$emit("update:scoutOtherJobFrom", $event)
              },
              "update:to": function ($event) {
                return _vm.$emit("update:scoutOtherJobTo", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("scout-form-candidate-other-job", {
        attrs: { "has-candidate-other-job": _vm.hasCandidateOtherJob },
        on: {
          "update:hasCandidateOtherJob": function ($event) {
            return _vm.$emit("update:has-candidate-other-job", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("scout-form-other-excludes", {
        attrs: { "applies-other-company": _vm.appliesOtherCompany },
        on: {
          "update:appliesOtherCompany": function ($event) {
            return _vm.$emit("update:applies-other-company", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }